<form [formGroup]="form" [class]="containerClasses">
  @for (input of inputs; track $index) {
  <div [class]="input.classes ?? ''">
    @if (input.kind === "normal") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      [ngClass]="{ 'read-only-disabled': input.readOnlyDisabled ?? false }"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
      class="w-100"
    >
      <mat-label>{{ input.label }}</mat-label>
      @if (input.iconPrefix) {
      <mat-icon matPrefix [svgIcon]="input.iconPrefix"></mat-icon>
      } @if (input.iconSuffix) {
      <mat-icon matSuffix [svgIcon]="input.iconSuffix"></mat-icon>
      }
      <input
        #formInput
        [attr.autocomplete]="input.autocomplete ?? 'off'"
        [attr.data-input-name]="input.name"
        [errorStateMatcher]="matcher"
        [formControlName]="input.name"
        [placeholder]="input.placeholder ?? ''"
        [type]="input.type"
        matInput
      />
      <mat-error>
        @for ( validator of input.validators.concat(input.asyncValidators ??
        []); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    } @if (input.kind === "special" && input.type === "tel") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      <mat-label>{{ input.label }}</mat-label>
      <div
        class="align-items-center d-flex ms-2 me-3"
        matPrefix
        [ngClass]="{ disabled: input.disabled ?? false }"
      >
        <mat-icon
          class="me-1"
          [svgIcon]="
            input.countryCodeName
              ? 'flag-' + input.countryCodeName
              : 'flag-empty'
          "
        ></mat-icon>
        <span>+{{ input.countryCodeNumber }}</span>
      </div>
      <input
        [attr.autocomplete]="input.autocomplete ?? 'off'"
        [errorStateMatcher]="matcher"
        [placeholder]="input.placeholder ?? ''"
        [type]="input.type"
        [formControlName]="input.name"
        matInput
      />
      <mat-error>
        @for ( validator of input.validators.concat(input.asyncValidators ??
        []); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    } @if (input.kind === "special" && input.type === "telWithIconSelect") {
    <div [formGroupName]="input.name" class="d-flex">
      <mat-form-field [appearance]="input.appearance ?? 'fill'" class="w-25">
        <mat-icon
          [svgIcon]="
            'flag-' +
            (input.value
              ? input.optionsMap.get(select.value)
              : select.value
              ? input.optionsMap.get(select.value)
              : 'empty')
          "
          class="me-1"
          matIconPrefix
        ></mat-icon>
        <mat-select #select formControlName="countryCode" placeholder="País">
          @for (option of input.options; track option.value) {
          <mat-option [value]="option.value">
            <mat-icon class="me-1" [svgIcon]="'flag-' + option.viewValue" />
            +{{ option.value }}
          </mat-option>
          }
        </mat-select>
        <mat-error>
          @for ( validator of input.validators.countryCode.concat(
          input.asyncValidators?.countryCode ?? [] ); track $index ) { @if (
          (form.get(input.name)?.get("countryCode")?.dirty ||
          form.get(input.name)?.get("countryCode")?.touched) && form
          .get(input.name) ?.get("countryCode")
          ?.hasError(validator.validatorErrorName) ) {
          <span [innerHTML]="validator.errorMessage"> </span>
          } }
        </mat-error>
      </mat-form-field>
      <mat-form-field [appearance]="input.appearance ?? 'fill'" class="w-75">
        <mat-label>{{ input.label }}</mat-label>
        <input
          [attr.autocomplete]="input.autocomplete ?? 'off'"
          [errorStateMatcher]="matcher"
          [placeholder]="input.placeholder ?? ''"
          [type]="input.type"
          formControlName="phoneNumber"
          matInput
        />
        <mat-error>
          @for ( validator of input.validators.phoneNumber.concat(
          input.asyncValidators?.phoneNumber ?? [] ); track $index ) { @if (
          (form.get(input.name)?.get("phoneNumber")?.dirty ||
          form.get(input.name)?.get("phoneNumber")?.touched) && form
          .get(input.name) ?.get("phoneNumber")
          ?.hasError(validator.validatorErrorName) ) {
          <span [innerHTML]="validator.errorMessage"> </span>
          } }
        </mat-error>
      </mat-form-field>
    </div>
    } @if (input.kind === "special" && input.type === "select") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      <mat-label>{{ input.label }}</mat-label>
      @if (input.iconPrefix) {
      <mat-icon matPrefix [svgIcon]="input.iconPrefix"></mat-icon>
      } @if (input.iconSuffix) {
      <mat-icon matSuffix [svgIcon]="input.iconSuffix"></mat-icon>
      }
      <mat-select
        (selectionChange)="selectOptionsChange($event, input.name)"
        [errorStateMatcher]="matcher"
        [formControlName]="input.name"
        [placeholder]="input.placeholder ?? ''"
      >
        @if (input.emptyOption) {
        <mat-option value="0">{{ input.emptyOption }}</mat-option>
        } @for (option of input.options; track $index) {
        <mat-option [value]="option.value">
          {{ option.viewValue }}
        </mat-option>
        } @if (input.addNewOption?.isEnabled) {
        <div class="m-auto pt-4 w-80">
          <button
            (click)="addNewOption(input.addNewOption?.id ?? 0)"
            class="button--accept w-100"
            mat-flat-button
          >
            {{ input.addNewOption?.name }}
          </button>
        </div>
        }
      </mat-select>
      <mat-error>
        @for ( validator of input.validators.concat(input.asyncValidators ??
        []); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    } @if (input.kind === "special" && input.type === "password") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      <mat-label>{{ input.label }}</mat-label>
      <input
        [attr.autocomplete]="input.autocomplete ?? 'off'"
        [errorStateMatcher]="matcher"
        [formControlName]="input.name"
        [type]="input.type"
        [placeholder]="input.placeholder ?? ''"
        #formInput
        matInput
      />
      <button
        (click)="passwordTypeVisibilityModifier(formInput)"
        class="me-1"
        mat-icon-button
        matSuffix
      >
        <mat-icon
          [ngClass]="{
            invalid:
              (form.get(input.name)?.dirty || form.get(input.name)?.touched) &&
              form.get(input.name)?.invalid
          }"
          class="icon--password"
          [svgIcon]="
            formInput.type === 'password' ? 'visibility' : 'visibility-off'
          "
        ></mat-icon>
      </button>
      @if (input.showErrors ?? true) {
      <mat-error>
        @for ( validator of input.validators.concat( input.asyncValidators ?? []
        ); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      } @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    @if (input.showRequirements) {
    <div class="ps-2 mb-4">
      <mat-list>
        <h5 class="fwc-500">Tu contraseña debe contener al menos:</h5>
        @for (requirement of input.requirements; track $index) {
        <mat-list-item class="d-flex h-100 mb-1">
          <mat-icon
            matListItemIcon
            [svgIcon]="
              form.get(input.name)?.dirty || form.get(input.name)?.touched
                ? form
                    .get(input.name)
                    ?.hasError(requirement.associatedErrorName)
                  ? 'close'
                  : 'check'
                : 'check'
            "
            [ngClass]="{
              success:
                (form.get(input.name)?.dirty ||
                  form.get(input.name)?.touched) &&
                !form
                  .get(input.name)
                  ?.hasError(requirement.associatedErrorName),
              error:
                (form.get(input.name)?.dirty ||
                  form.get(input.name)?.touched) &&
                form.get(input.name)?.hasError(requirement.associatedErrorName)
            }"
          ></mat-icon>
          <span class="text-color--accent--aux2">{{ requirement.title }}</span>
        </mat-list-item>
        }
      </mat-list>
    </div>
    } } @if (input.kind === "special" && input.type === "numerical") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      [ngClass]="{ 'read-only-disabled': input.readOnlyDisabled ?? false }"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      @if (input.label) {
      <mat-label>{{ input.label }}</mat-label>
      } @if (input.iconPrefix) {
      <mat-icon matPrefix [svgIcon]="input.iconPrefix"></mat-icon>
      } @if (input.iconSuffix) {
      <mat-icon matSuffix [svgIcon]="input.iconSuffix"></mat-icon>
      } @if ( input.currency === "outside" && (input._isLabelFloating ||
      form.get(input.name)!.value) ) {
      <span class="text-color--primary" matTextPrefix>$</span>
      } @else if ( input.percentage && (input._isLabelFloating ||
      form.get(input.name)!.value) ) {
      <span class="text-color--primary" matTextPrefix>%</span>
      }
      <app-numerical-input
        (shouldLabelFloatEvent)="input._isLabelFloating = !$event"
        [allowOnlyDecimal]="input.allowOnlyDecimal ?? false"
        [currency]="input.currency ?? ''"
        [formControlName]="input.name"
        [inputName]="input.name"
        [inputStyle]="input.inputStyle ?? {}"
        [percentage]="input.percentage ?? false"
        [placeholder]="input.placeholder ?? ''"
        [defaultBehavior]="input.defaultBehavior ?? true"
        #formInput
      ></app-numerical-input>
      @if (input.showErrors ?? true) {
      <mat-error>
        @for ( validator of input.validators.concat( input.asyncValidators ?? []
        ); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      } @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    } @if (input.kind === "special" && input.type === "date") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      <mat-label>{{ input.label }}</mat-label>
      <input
        #formInput
        [matDatepicker]="picker"
        [errorStateMatcher]="matcher"
        [formControlName]="input.name"
        [placeholder]="input.placeholder ?? ''"
        [min]="minDate"
        (click)="picker.open()"
        matInput
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error>
        @for ( validator of input.validators.concat(input.asyncValidators ??
        []); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    } @if (input.kind === "special" && input.type === "autocomplete") {
    <mat-form-field
      [appearance]="input.appearance ?? 'fill'"
      class="w-100"
      [subscriptSizing]="input.subscriptSizing ?? 'fixed'"
      [floatLabel]="input.floatLabel ?? 'auto'"
    >
      <mat-label>{{ input.label }}</mat-label>
      @if (input.iconPrefix) {
      <mat-icon matPrefix [svgIcon]="input.iconPrefix"></mat-icon>
      } @if (input.iconSuffix) {
      <mat-icon matSuffix [svgIcon]="input.iconSuffix"></mat-icon>
      }
      <input
        (input)="autocompleteFilters(formInput)"
        [attr.data-input-name]="input.name"
        [errorStateMatcher]="matcher"
        [formControlName]="input.name"
        [matAutocomplete]="auto"
        [placeholder]="input.placeholder ?? ''"
        #formInput
        matInput
        type="text"
      />
      <mat-autocomplete
        (optionSelected)="autocompleteOptionsSelected($event, input.name)"
        [displayWith]="input.displayFn"
        #auto="matAutocomplete"
      >
        @if (input.componentOptions) { @for (option of input.componentOptions;
        track option) {
        <mat-option [value]="option.value">
          <ng-container
            *ngComponentOutlet="option.component; inputs: option.inputs"
          ></ng-container>
        </mat-option>
        } } @else { @for (option of input.options; track option) {
        <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
        } }
      </mat-autocomplete>
      <mat-error>
        @for ( validator of input.validators.concat(input.asyncValidators ??
        []); track $index ) { @if ( (form.get(input.name)?.dirty ||
        form.get(input.name)?.touched) &&
        form.get(input.name)?.hasError(validator.validatorErrorName) ) {
        <span [innerHTML]="validator.errorMessage"> </span>
        } }
      </mat-error>
      @if (input.hint) {
      <mat-hint>{{ input.hint }}</mat-hint>
      }
    </mat-form-field>
    }
  </div>
  }
</form>
